import { useEffect } from "react";
import Select from "react-select";
import AsteriskSymbol from "../../../../reusableComponents/AsteriskSymbol";
import { toast } from "react-toastify";
import { getBasicSearchResults } from "./apiHelper";

const Search = (props) => {
  const {
    productName,
    searchTypes,
    setShowAdvanceSearch,
    searchFields,
    setSearchFields,
    setSearchResults,
    setLoading,
  } = props;
  const basicSearch = async () => {
    if (!searchFields.product_name) {
      toast.error("Please Select Product Name");
      return;
    }
    if (!searchFields.search_type.value) {
      toast.error("Please Select Search Type");
      return;
    }
    if (!searchFields.search_type_value) {
      toast.error(`Please Enter ${searchFields.search_type.label}`);
      return;
    }
    if (
      searchFields.search_type.value === 2 &&
      searchFields.search_type_value.length !== 10
    ) {
      toast.error("Mobile number should be 10 digit");
      return;
    }
    const data = await getBasicSearchResults(searchFields, setLoading);
    if (data?.data && data.data !== "No Data Present") {
      setSearchResults(data.data);
    } else {
      setSearchResults([]);
    }
  };
  useEffect(() => {
    if (productName.length) {
      setSearchFields((prev) => ({ ...prev, product_name: productName[0] }));
    }
  }, []);
  return (
    <div>
      <h5 className="m-4">Search</h5>
      <div className="border rounded p-4 px-1">
        <div className="d-md-flex align-items-center justify-content-evenly">
          <div className="form-group col-md-3 ms-3">
            <label>
              Product Name <AsteriskSymbol />
            </label>
            <Select
              options={productName}
              onInputChange={(inputValue) => {
                // Replace non-alphanumeric characters
                const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                return cleanedValue; // Return cleaned value for the Select component
              }}
              classNamePrefix="bg-gray"
              placeholder="Select Kshema Product"
              value={
                searchFields.product_name.label
                  ? searchFields.product_name
                  : null
              }
              onChange={(data) => {
                setSearchResults(null);
                if (searchFields.search_type.value === 4) {
                  setSearchFields({
                    ...searchFields,
                    state: "",
                    district: "",
                    mandal: "",
                    village: "",
                    pincode: "",
                    policyHolderName: "",
                    search_type: { label: "Policy ID", value: 1 },
                    search_type_value: "",
                    product_name: data,
                  });
                } else {
                  setSearchFields({
                    ...searchFields,
                    product_name: data,
                  });
                }
              }}
            />
          </div>
          <div className="form-group col-md-3 mx-3">
            <label>
              Search Type <AsteriskSymbol />
            </label>
            <Select
              options={searchTypes}
              onInputChange={(inputValue) => {
                // Replace non-alphanumeric characters
                const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                return cleanedValue; // Return cleaned value for the Select component
              }}
              isDisabled={!searchFields.product_name}
              classNamePrefix="bg-gray"
              placeholder="Select Search Type"
              value={
                searchFields.search_type.label
                  ? searchFields.search_type
                  : {
                      label: "Select Search Type",
                      value: "Select Search Type",
                    }
              }
              onChange={(data) => {
                setSearchResults(null);
                setSearchFields({
                  ...searchFields,
                  state: "",
                  district: "",
                  mandal: "",
                  village: "",
                  pincode: "",
                  crop: "",
                  policyHolderName: "",
                  search_type_value: "",
                  search_type: data,
                });
                data.label === "Advance Search"
                  ? setShowAdvanceSearch(true)
                  : setShowAdvanceSearch(false);
                setSearchResults(null);
              }}
            />
          </div>
          <div className="form-group col-md-3 mx-3">
            {searchFields.search_type.label !== "Advance Search" && (
              <>
                <label>{searchFields.search_type.label}</label>
                <span className="text-danger">*</span>
                <input
                  type="text"
                  className="form-control bg-gray"
                  placeholder={`Enter ${searchFields.search_type.label}`}
                  maxLength={
                    searchFields.search_type.value === 2
                      ? 10
                      : searchFields.search_type.value === 1 ||
                        searchFields.search_type.value === 3
                      ? 50
                      : ""
                  }
                  minLength={searchFields.search_type.value === 2 ? 10 : ""}
                  onChange={(e) => {
                    setSearchResults(null);
                    if (
                      searchFields.search_type.value === 2 ||
                      searchFields.search_type.value === 1
                    ) {
                      if (/[^A-Za-z\d\/]/.test(e.target.value)) {
                        return;
                      }
                    }
                    if (searchFields.search_type.value === 2) {
                      const numericValue = e.target.value.replace(
                        /[^0-9.,]/g,
                        ""
                      );
                      e.target.value = numericValue;
                      setSearchFields({
                        ...searchFields,
                        search_type_value: e.target.value,
                      });
                    } else {
                      const numericValue = e.target.value.replace(
                        /[^A-Za-z0-9-\/]/g,
                        ""
                      ); // Replace non-alphanumeric characters
                      e.target.value = numericValue;
                      setSearchFields({
                        ...searchFields,
                        search_type_value: e.target.value,
                      });
                    }
                  }}
                  value={searchFields.search_type_value}
                  // Additional attributes to prevent autofill
                  name="mobile-number"
                  autoComplete="mobile-number-new"
                  data-autofill-type="mobile-number"
                />
              </>
            )}
          </div>
          <div className="form-group col-md-3 mx-3">
            {searchFields.search_type.label !== "Advance Search" && (
              <button
                className="btn btn-success m-3 ms-0 mb-0 px-4"
                disabled={
                  !searchFields.product_name && !searchFields.search_type_value
                }
                onClick={() => basicSearch()}
              >
                Search
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
